module.exports = __webpack_public_path__ + "static/media/A1-4-Strylik-cod86.3d19c671.png";